export const navigateAndScroll = (hash: string) => {
  if (window.location.hash !== `#${hash}`) {
    window.location.hash = hash // Directly sets the hash
  }
  scrollToElementById(hash)
}

const scrollToElementById = (id: string) => {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  } else {
    console.error(`Element with ID "${id}" not found.`)
  }
}
